/* istanbul ignore next */
const ACTIONS = {
    FETCH_PREVIEWS: 'FETCH_PREVIEWS',
    FETCH_PREVIEWS_START: 'FETCH_PREVIEWS_START',
    FETCH_PREVIEWS_SUCCESS: 'FETCH_PREVIEWS_SUCCESS',
    FETCH_PREVIEWS_ERROR: 'FETCH_PREVIEWS_ERROR',
    FETCH_DETAILS: 'FETCH_DETAILS',
    FETCH_DETAILS_START: 'FETCH_DETAILS_START',
    FETCH_DETAILS_SUCCESS: 'FETCH_DETAILS_SUCCESS',
    FETCH_DETAILS_ERROR: 'FETCH_DETAILS_ERROR',
    FETCH_COLLABORATOR_COUNT: 'FETCH_COLLABORATOR_COUNT',
    FETCH_COLLABORATOR_COUNT_START: 'FETCH_COLLABORATOR_COUNT_START',
    FETCH_COLLABORATOR_COUNT_SUCCESS: 'FETCH_COLLABORATOR_COUNT_SUCCESS',
    FETCH_COLLABORATOR_COUNT_ERROR: 'FETCH_COLLABORATOR_COUNT_ERROR',
    DELETE_TRIPBOARD: 'DELETE_TRIPBOARD',
    DELETE_TRIPBOARD_START: 'DELETE_TRIPBOARD_START',
    DELETE_TRIPBOARD_SUCCESS: 'DELETE_TRIPBOARD_SUCCESS',
    DELETE_TRIPBOARD_ERROR: 'DELETE_TRIPBOARD_ERROR',
    DELETE_TRIPBOARD_LISTING: 'DELETE_TRIPBOARD_LISTING',
    DELETE_TRIPBOARD_LISTING_START: 'DELETE_TRIPBOARD_LISTING_START',
    DELETE_TRIPBOARD_LISTING_SUCCESS: 'DELETE_TRIPBOARD_LISTING_SUCCESS',
    DELETE_TRIPBOARD_LISTING_ERROR: 'DELETE_TRIPBOARD_LISTING_ERROR',
    RENAME_TRIPBOARD: 'RENAME_TRIPBOARD',
    RENAME_TRIPBOARD_START: 'RENAME_TRIPBOARD_START',
    RENAME_TRIPBOARD_SUCCESS: 'RENAME_TRIPBOARD_SUCCESS',
    RENAME_TRIPBOARD_ERROR: 'RENAME_TRIPBOARD_ERROR',
    DELETE_TRIPBOARD_DATES: 'DELETE_TRIPBOARD_DATES',
    DELETE_TRIPBOARD_DATES_START: 'DELETE_TRIPBOARD_DATES_START',
    DELETE_TRIPBOARD_DATES_SUCCESS: 'DELETE_TRIPBOARD_DATES_SUCCESS',
    DELETE_TRIPBOARD_DATES_ERROR: 'DELETE_TRIPBOARD_DATES_ERROR',
    UPDATE_TRIPBAORD_DATES: 'UPDATE_TRIPBAORD_DATES',
    UPDATE_TRIPBAORD_DATES_START: 'UPDATE_TRIPBAORD_DATES_START',
    UPDATE_TRIPBAORD_DATES_SUCCESS: 'UPDATE_TRIPBAORD_DATES_SUCCESS',
    UPDATE_TRIPBAORD_DATES_ERROR: 'UPDATE_TRIPBAORD_DATES_ERROR',
    SET_CURRENT_TRIPBOARD: 'SET_CURRENT_TRIPBOARD',
    CREATE_TRIPBOARD_INVITATION: 'CREATE_TRIPBOARD_INVITATION',
    CREATE_TRIPBOARD_INVITATION_START: 'CREATE_TRIPBOARD_INVITATION_START',
    CREATE_TRIPBOARD_INVITATION_SUCCESS: 'CREATE_TRIPBOARD_INVITATION_SUCCESS',
    CREATE_TRIPBOARD_INVITATION_ERROR: 'CREATE_TRIPBOARD_INVITATION_ERROR',
    COMPLETED_TRIPBOARD_ONBOARDING: 'COMPLETED_TRIPBOARD_ONBOARDING'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchCollaboratorCount: (boardId) => ({type: ACTIONS.FETCH_COLLABORATOR_COUNT, payload: {boardId}}),
    deleteTripboardListing: (boardId, listingId) => ({type: ACTIONS.DELETE_TRIPBOARD_LISTING, payload: {boardId, listingId}}),
    renameTripboard: (boardId, name) => ({type: ACTIONS.RENAME_TRIPBOARD, payload: {boardId, name}}),
    deleteTripboardDates: (boardId) => ({type: ACTIONS.DELETE_TRIPBOARD_DATES, payload: {boardId}}),
    updateTripboardDates: (boardId, startDate, endDate) => ({
        type: ACTIONS.UPDATE_TRIPBAORD_DATES,
        payload: {boardId, startDate, endDate}
    }),
    setCurrentTripboard: (boardId) => ({type: ACTIONS.SET_CURRENT_TRIPBOARD, payload: {boardId}}),
    createInvitation: (boardId) => ({type: ACTIONS.CREATE_TRIPBOARD_INVITATION, payload: {boardId}}),
    completeOnboarding: () => ({type: ACTIONS.COMPLETED_TRIPBOARD_ONBOARDING})
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/actions.js